"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _alipay = _interopRequireDefault(require("payment-icons/min/flat/alipay.svg"));

var _discover = _interopRequireDefault(require("payment-icons/min/flat/discover.svg"));

var _hipercard = _interopRequireDefault(require("payment-icons/min/flat/hipercard.svg"));

var _paypal = _interopRequireDefault(require("payment-icons/min/flat/paypal.svg"));

var _unionpay = _interopRequireDefault(require("payment-icons/min/flat/unionpay.svg"));

var _visa = _interopRequireDefault(require("payment-icons/min/flat/visa.svg"));

var _amex = _interopRequireDefault(require("payment-icons/min/flat/amex.svg"));

var _diners = _interopRequireDefault(require("payment-icons/min/flat/diners.svg"));

var _elo = _interopRequireDefault(require("payment-icons/min/flat/elo.svg"));

var _jcb = _interopRequireDefault(require("payment-icons/min/flat/jcb.svg"));

var _maestro = _interopRequireDefault(require("payment-icons/min/flat/maestro.svg"));

var _mastercard = _interopRequireDefault(require("payment-icons/min/flat/mastercard.svg"));

var _verve = _interopRequireDefault(require("payment-icons/min/flat/verve.svg"));

var _default2 = _interopRequireDefault(require("payment-icons/min/flat/default.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cardsByName = {
  alipay: _alipay["default"],
  discover: _discover["default"],
  hipercard: _hipercard["default"],
  paypal: _paypal["default"],
  unionpay: _unionpay["default"],
  visa: _visa["default"],
  amex: _amex["default"],
  diners: _diners["default"],
  elo: _elo["default"],
  jcb: _jcb["default"],
  maestro: _maestro["default"],
  mastercard: _mastercard["default"],
  verve: _verve["default"]
};

var PaymentIcon = function PaymentIcon(_ref) {
  var id = _ref.id,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: cardsByName[id] || _default2["default"],
    style: _objectSpread({
      display: 'inline',
      marginTop: 2
    }, style)
  });
};

var _default = PaymentIcon;
exports["default"] = _default;